class customDesignForm {
    constructor() {
        this.container = document.querySelector('[data-requestFormParent]');
        this.form = document.querySelector('[data-designRequestForm]');
        this.submitBtn = document.querySelector('[data-designRequestForm] button[type="submit"]');
        this.fileUpload = document.querySelector('[data-designRequestForm] input[name="reference-image"]');
        this.datepicker = document.querySelector('[data-designRequestForm] input.date-input');
        this.thankyouScreen = document.querySelector('[data-requestFormParent] .thank_you_screen');
        this.scrollToFormBtns = document.querySelectorAll('[data-openCustomForm], a[href="#openCustomRequestForm"]');
        this.visibleForm = document.querySelector("[data-thankYouBlockcloseBtn]"); 
        const requiredSteps = Array.from(this.form.querySelectorAll('.required-step'));
        this.requiredKeys = requiredSteps.map(step => step.dataset.key).filter(key => key !== null);

        this._setupEventListeners();
    }
  
    _trackConversion(){
        gtag("event", "conversion", {
            "send_to": "AW-16556230402/U8xeCOGA-bEZEIKO0NY9",
            "event_callback": null
        });
        fbq('track', 'CompleteRegistration');   
    }

    /**
     * Bind click events on toggle button
     */
    _setupEventListeners() {
        this.form.addEventListener('submit', (evt)=>{
            evt.preventDefault();
            let validForm = this._validForSubmission();
            if(!validForm) return;

            this._submitForm(evt);
        });
        this.form.addEventListener('input', (_evt) =>{
            let invalidEle = this.form.querySelectorAll('.required-step.is-invalid');
            invalidEle.forEach(ele => ele.classList.remove('is-invalid'));
        });
        this.scrollToFormBtns.forEach(btn => {
            btn.addEventListener('click', (evt)=> {
                evt.preventDefault();
                this.form.scrollIntoView({ behavior: "smooth", block: "nearest"});
            });
        });
        if(this.fileUpload) this.fileUpload.addEventListener('change', this._manageFileUpload.bind(this));
        if(this.datepicker){
            let lookForFlatpickr = setInterval(() => {
                if(typeof flatpickr == 'function'){
                    this.datepicker.flatpickr({
                        disableMobile: "true",
                        minDate: this.datepicker.min
                    });
                    clearInterval(lookForFlatpickr);
                } 
            }, 100);
        }
        this.visibleForm.addEventListener("click",(event)=>{
            this._openForm(event)
         })
    }

    _openForm(event){
        this.container.classList?.remove('show-thankyou-screen');   
    }

    _validForSubmission(){
        const formData = new FormData(this.form);
        let validInputs = true;
        this.requiredKeys.forEach((key) => {
            let value = (formData.get(key) != null && formData.get(key) != undefined) ? formData.get(key).trim() : '';
            if(value.length == 0) {
                validInputs = false;
                let element = this.form.querySelector(`[name="${key}"]`);
                if(element) element.closest('.required-step').classList.add('is-invalid');
            }
        });

        if(!validInputs){            
            window.notificationEle.updateNotification('Input required!', 'Please fill in required details to submit the request.', {
                type: 'error',
                timeout: 10000
            });
            return false;
        }else if(!Utility.validateEmail(formData.get('email'))){
            window.notificationEle.updateNotification('Invalid email!', 'Please provide valid email', {
                type: 'error',
                timeout: 10000
            });
            return false;
        }

        return true;
    }

    async _submitForm(event){
        event.preventDefault();
        let formData = new FormData(this.form);
        let email = formData.get('email');
        let properties = {};

        if(!Utility.validateEmail(email)){
            window.notificationEle.updateNotification('Input required!', 'Please provide valid email to submit selection.', {
                type: 'error',
                timeout: 5000
            });
            return;
        }

        // Collect profile attributes
        let profileAttributes = {
            email: formData.get('email'),
            first_name: formData.get('first_name'),
            last_name: formData.get('last_name')
        }
        if(formData.get('phone_number') != '') profileAttributes['phone_number'] = formData.get('phone_number');
        
        // Collect custom design request event properties
        for(let [key, value] of formData.entries()){
            if(key == 'reference-image') {
                value = this.form.querySelector('input[name="reference-image"]').dataset.cdn || '';
            }

            let current = properties[key];
            if(key != 'first_name' && key != 'last_name' && key != 'email' && key != 'phone_number' && value != null){
                if(current == undefined){
                    properties[key] = value.trim();
                }else{
                    properties[key] = `${properties[key]},${value.trim()}`;
                }
            }
        }
    
        this.submitBtn.disabled = true;
        const eventData = {
            type: 'event',
            attributes: {
                properties: properties,
                metric: {data: {type: 'metric', attributes: {name: 'Design your own jewellery form submitted'}}},
                profile: {
                    data: {
                        type: 'profile',
                        attributes: profileAttributes
                    }
                }
            }
        };

        try {
            let fetchResponse = await this._registerKlaviyoEvt(eventData);
            if(fetchResponse.ok){
                this.container.classList.add('show-thankyou-screen');   
                // this._trackConversion();
                
                this.thankyouScreen.scrollIntoView({ behavior: "smooth", block: "nearest"}); 
                this._addCustomerToList(formData.get('email'), properties);
            }else{
                let errRes = (typeof fetchResponse == 'object') ? fetchResponse : JSON.parse(fetchResponse);
                let title = (errRes.errors) ? errRes.errors[0].title : 'Invalid Input';
                let detail = (errRes.errors) ? errRes.errors[0].detail : 'Provide valid details';
                window.notificationEle.updateNotification(title, detail, {
                    type: 'error',
                    timeout: 10000
                });
                this.submitBtn.removeAttribute('disabled');
            }
        }catch(error){
            this.submitBtn.removeAttribute('disabled');
            window.notificationEle.updateNotification('Something went wrong!', JSON.stringify(error), {
                type: 'error',
                timeout: 10000
            });
            throw error;
        }
    }

    async _registerKlaviyoEvt(eventData){
        const apiResponse = await fetch("https://a.klaviyo.com/client/events/?company_id=UGMHdn", {
            method: "POST",
            headers: {'revision': '2024-05-15', 'content-type': 'application/json', 'accept': 'application/json'},
            body: JSON.stringify({
                data: eventData
            })
        })

        if(!apiResponse.ok) {
            return apiResponse.text();
        }else {
           return (typeof apiResponse == 'object') ? apiResponse : apiResponse.json();
        } 
    }

    async _manageFileUpload(event){
        let input = event.currentTarget;
        const fileErr = this.form.querySelector('.file-upload-error');
        const fileName = this.form.querySelector('label.upload-file .file-name');
        const progressMsg = this.form.querySelector('.image-upload-progress-msg');

        fileErr.classList.add('d-none');

        if(input.value == '' || input.files[0] == undefined){
            fileName.innerHTML = 'Upload Image here';
            return;
        }else{
            fileName.innerHTML = input.files[0].name;
        }

        const fileSizeKB = Math.round((input.files[0].size / 1024));
        if(fileSizeKB > 5130){
            fileErr.querySelector('.filesize').innerText = input.files[0].size / (1024**2);
            fileErr.classList.remove('d-none');
        }
        
        const base64 = await Utility.convertImageToBase64(input.files[0]);
        if(base64 == null) return;

        const imageDimentions = await Utility.checkFormDimentions(base64);
        if(imageDimentions.width > 5000 || imageDimentions.height > 5000){
            window.notificationEle.updateNotification('Image size too large!', `maximum dimentions allowed are 5000*5000. Upload image is of ${imageDimentions.width}*${imageDimentions.height}`, {
                type: 'error',
                timeout: 5000
            });
            input.value = null; input.dispatchEvent(new Event('change'));
            return;
        }

        progressMsg.classList.remove('d-none');
        this.submitBtn.disabled = true;
        fetch('https://certificate-manager.diamondrensu.com/api/image/upload', {
            method: 'POST',
            headers: { 
                'Content-type': 'application/json; charset=UTF-8', 
                'X-Shop': '257a2f-1d.myshopify.com'  
            },
            body: JSON.stringify({image: base64})            
        })
        .then((response) => { 
            return response.json()})
        .then((data) => {
            if(data.errors){
                const errorMsg = (data.errors.image) ? JSON.stringify(data.errors.image) : JSON.stringify(data.errors)
                input.value = null; input.dispatchEvent(new Event('change'));
                input.removeAttribute('data-cdn');
                window.notificationEle.updateNotification('Something went wrong!', errorMsg, {
                    type: 'error',
                    timeout: 5000
                });
            }else{
                input.dataset.cdn = data.image_url;
            }
            progressMsg.classList.add('d-none');
            this.submitBtn.removeAttribute('disabled');
        }).catch(error => {
            console.error('Error:', error);
            input.value = null; input.dispatchEvent(new Event('change'));
            input.removeAttribute('data-cdn');
            window.notificationEle.updateNotification('Something went wrong!', error, {
                type: 'error',
                timeout: 5000
            });

            progressMsg.classList.add('d-none');
            this.submitBtn.removeAttribute('disabled');
        }); 
    }

    async _addCustomerToList(customerEmail , properties){
        const senderData = {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: customerEmail,
                  },
                }
              }
            },
            relationships: {list: {data: {type: 'list', id: 'QS7w2n'}}}
        }
        
        const apiResponse = await fetch("https://a.klaviyo.com/client/subscriptions/?company_id=UGMHdn", {
            method: "POST",
            headers: {'revision': '2024-05-15', 'content-type': 'application/json'},
            body: JSON.stringify({
                data: senderData
            })
        });

        return apiResponse;
    }
}
typeof customDesignForm !== 'undefined' && new customDesignForm();
